import Box from "@mui/material/Box";
import {Button} from "@mui/material";
import {Add} from "@mui/icons-material";
import useOrderItemRepository from "../../../../../../repository/emergency/useOrderItemRepository";
import {useEffect} from "react";
import isNull from "../../../../../../mixin/isNull";
import useAlert from "../../../../../../use/useAlert";
import useOrderRepository from "../../../../../../repository/emergency/useOrderRepository";
import parameter from "../../../../../../enum/parameter";
import DefaultItem from "../../../../../../entity/emergency/DefaultItem";

export default function ({orderId, onAdd, currentQuotationItems}) {
    const alert = useAlert();
    const orderRepository = useOrderRepository();
    const orderItemRepository = useOrderItemRepository();
    /** @type OrderItem[] */
    const orderItems = orderItemRepository.findAllByOrderId(orderId).select();
    /** @type Order */
    const order = orderRepository.findOneById(orderId).select();

    useEffect(() => {
        orderRepository.findOneById(orderId).exec();
        orderItemRepository.findAllByOrderId(orderId).exec();
    }, []);

    const handleAdd = (defaultItemId, name) => () => {
        const orderItem = orderItems.find(oi => oi.getDefaultItemId() === defaultItemId);

        if (isNull(orderItem)) {
            alert.error("Une erreur s'est produite");
            return;
        }

        onAdd({
            name: name,
            description: null,
            price: orderItem.getPrice(),
            quantity: 1,
            standardized_item_id: null,
            default_item_id: null
        })
    }

    if (isNull(orderItems) || isNull(order) || order.isWithoutSupportedPrice()) return null;

    return (
        <>
            <Box display={"flex"} justifyContent="center">
                <Button
                    startIcon={<Add/>}
                    variant={"contained"}
                    sx={{width: "80%"}}
                    onClick={handleAdd(DefaultItem.SHIFTING, parameter.ADDITIONAL_SHIFTING_NAME)}
                    disabled={!isNull(currentQuotationItems.find(cqi => cqi.name === parameter.ADDITIONAL_SHIFTING_NAME))}
                    data-test="button-add-shifting"
                >
                    {parameter.ADDITIONAL_SHIFTING_NAME}
                </Button>
            </Box>
            <Box mt={1} display={"flex"} justifyContent="center">
                <Button
                    startIcon={<Add/>}
                    variant={"contained"}
                    sx={{width: "80%"}}
                    onClick={handleAdd(DefaultItem.MAIN_WORK, parameter.ADDITIONAL_MAIN_WORK_NAME)}
                    disabled={!isNull(currentQuotationItems.find(cqi => cqi.name === parameter.ADDITIONAL_MAIN_WORK_NAME))}
                    data-test="button-add-main-work"
                >
                    {parameter.ADDITIONAL_MAIN_WORK_NAME}
                </Button>
            </Box>
        </>
    )
}